import { render } from "./Giftcard.vue?vue&type=template&id=59e01d1a&scoped=true"
import script from "./Giftcard.vue?vue&type=script&lang=js"
export * from "./Giftcard.vue?vue&type=script&lang=js"

import "./Giftcard.vue?vue&type=style&index=0&id=59e01d1a&scoped=true&lang=css"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e01d1a"]])

export default __exports__